// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-sidebar-group + .au-sidebar-group {
  margin-top: var(--admin-s6);
}

.au-sidebar-group__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--admin-s3);
  margin-bottom: var(--admin-s3);
}

.au-sidebar-group__label {
  color: var(--admin-text-muted);
  font-size: var(--admin-text-micro);
  font-weight: var(--admin-font-weight-bold);
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.au-sidebar-group__toggle {
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--admin-text-secondary);
  font-size: var(--admin-text-xs);
  font-weight: var(--admin-font-weight-semibold);
  cursor: pointer;
}

.au-sidebar-group__toggle:hover {
  color: var(--admin-text-primary);
}

.au-sidebar-group__rows {
  display: grid;
  gap: var(--admin-s1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminSidebarGroup.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;EAC1C,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,+BAA+B;EAC/B,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB","sourcesContent":[".au-sidebar-group + .au-sidebar-group {\n  margin-top: var(--admin-s6);\n}\n\n.au-sidebar-group__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--admin-s3);\n  margin-bottom: var(--admin-s3);\n}\n\n.au-sidebar-group__label {\n  color: var(--admin-text-muted);\n  font-size: var(--admin-text-micro);\n  font-weight: var(--admin-font-weight-bold);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.au-sidebar-group__toggle {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: var(--admin-text-secondary);\n  font-size: var(--admin-text-xs);\n  font-weight: var(--admin-font-weight-semibold);\n  cursor: pointer;\n}\n\n.au-sidebar-group__toggle:hover {\n  color: var(--admin-text-primary);\n}\n\n.au-sidebar-group__rows {\n  display: grid;\n  gap: var(--admin-s1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
